export const fieldMaxLength = 32;
export const maxFieldsForSplittedScreen = 4;
export const maxCoverIdx = 4;

export const activeCodes = {
    ACTIVE: '89',
    INACTIVE: '78'
};

/*
    0  => Shown for all users
    H: 72 => Hidden for all users
    N: 78 => Hidden for all users
    S: 83 => Shown for all users
    h: 104 => hidden for all users and current user by package
    s: 115 => Shown for all users and hidden for current user by package
    P: 80 => hidden because package is hidden for this user
*/

export enum hiddenFieldTypes {
    HIDDEN = '72',
    HIDDEN_TMP = '78',
    SHOWN = '0',
    PACKAGE_HIDDEN = '80',
    SHOWN_FORMAT = '83',
    HIDDEN_BOTH = '104',
    HIDDEN_IN_PACKAGE = '115'
}
